"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16LogoApple = function Svg16LogoApple(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M16.513 12.01c.024 2.567 2.252 3.421 2.277 3.432-.02.06-.356 1.217-1.174 2.412-.707 1.033-1.44 2.063-2.596 2.084-1.136.02-1.501-.673-2.8-.673-1.297 0-1.703.652-2.778.694-1.116.042-1.965-1.117-2.678-2.147-1.456-2.105-2.57-5.95-1.075-8.545.743-1.288 2.07-2.105 3.51-2.125 1.095-.021 2.129.737 2.799.737.669 0 1.925-.912 3.246-.778.553.023 2.106.223 3.102 1.682-.08.05-1.852 1.082-1.833 3.227zM14.38 5.708c.592-.717.991-1.715.882-2.708-.853.034-1.886.569-2.498 1.285-.549.635-1.03 1.65-.9 2.624.952.073 1.924-.484 2.516-1.201",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16LogoApple.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16LogoApple;
exports.default = _default;